import {lazy} from "react";

export function lazyWithPreload(factory) {
    const Component = lazy(factory);
    Component.preload = factory;
    return Component;
}
